import { Box, useMediaQuery } from "@mui/material";
import { ReactElement } from "react";
import { useSelector } from "react-redux";

import { RootState } from "../../redux/store";
import DesktopNavBox from "../desktopNavBox/DesktopNavBox";
import ProfileSideBar from "../profileSideBar/ProfileSideBar";

interface InnerLayoutProps {
  children: ReactElement;
}

const InnerLayout = ({ children }: InnerLayoutProps) => {
  const isMdSize = useMediaQuery("(min-width:900px)");
  const userUid = useSelector((state: RootState) => state.user.user.uid);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "1184px",
        p: { md: 4 },
        display: "flex",
        justifyContent: "space-between",
        gap: "3.6rem",
      }}
    >
      {isMdSize && (
        <Box
          sx={{
            width: "17.875rem",
            minWidth: "17.875rem",
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          <DesktopNavBox />
          <ProfileSideBar />
        </Box>
      )}
      {children}
    </Box>
  );
};

export default InnerLayout;
